import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateEventService, type UpdateEventPayload } from '@/services/events'

export const useUpdateEvent = (agendaId: string, eventId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: UpdateEventPayload) => updateEventService(agendaId, eventId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agendas', agendaId, 'events'] })
      queryClient.invalidateQueries({ queryKey: ['calendar'] })
    },
  })
}
